import { GetServerSideProps } from 'next'
import React from 'react'

import { SinglePostWrap } from '@Components/CMS/SinglePostWrap'
import { GetInspired } from '@Components/SideBar/GetInspired'
import { Page, PageType } from '@Generated/graphql'
import { initializeApolloFromContext } from '@Globals/Apollo/Server'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { PageHOC } from '@Globals/Page/Client'
import { boostFromContext, handleRedirect, pageProps } from '@Globals/Page/Server'
import { PageProps } from '@Globals/Page/Types'
import { OneColumn } from '@Layouts/OneColumn'
import { getSinglePost } from '@Queries/cms/SinglePost.query'
import TrackingDataQuery from '@Queries/cms/TrackingData.query'

import styles from './TrackingPage.module.scss'

interface TrackingProps extends PageProps {
  item: Page
}

export const getServerSideProps: GetServerSideProps<TrackingProps> = async (context) => {
  const apolloClient = initializeApolloFromContext(context)
  const post = await getSinglePost(
    apolloClient,
    PageType.Tracking,
    '/tracking',
    undefined,
    boostFromContext(context),
    context?.req?.thSplitTests,
  )
  const { page } = post.data

  const { query } = context

  if (query?.trackingToken) {
    try {
      await apolloClient.query({
        query: TrackingDataQuery,
        variables: {
          token: query.trackingToken?.toString(),
          orderNumber: query.orderNumber?.toString(),
        },
      })
    } catch (e) {
      console.warn('could not fetch tracking data')
    }
  }

  if (!page) {
    return {
      notFound: true,
    }
  }

  if (page?.type === 'redirect_permanent' || page?.type === 'redirect_temporary') {
    return handleRedirect(context, page.url, page.type)
  }

  return {
    props: {
      ...await pageProps(
        context,
        { type: 'tracking', id: '1' },
        page,
        ['cart', 'common', 'cms', 'footer', 'header', 'sidebar', 'validation', 'shipping', 'tracking', 'products'],
        true,
      ),
      item: page as Page,
      initialApolloState: apolloClient.cache.extract(),
    },
  }
}

const TrackingPage = PageHOC<TrackingProps>(({ item }) => {
  const components = useBlockComponents(item.blocks || [])

  return (
    <OneColumn>
      <SinglePostWrap>
        {components}
        <div className={styles.trackingMobileInspiration}>
          <GetInspired largeImages />
        </div>
      </SinglePostWrap>
    </OneColumn>
  )
})

export default TrackingPage
